<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseDifficultyList.push"
    :is-show-search-input="true"
    search-placeholder="输入课程难度名称进行搜索"
  >
    <v-column-time/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="ID" prop="id"/>
    <el-table-column label="课程难度名称" prop="difficulty_name"/>
    <el-table-column v-if="isAdministrator" width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.courseDifficultyEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此课程难度吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`course-difficulty-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>课程难度名称</span>
              <span>{{ v.difficulty_name }}</span>
            </div>

            <div class="list-item-button">
              <template v-if="isAdministrator">
                <v-list-button :to="RouteConfig.courseDifficultyEdit.to(v.id)"/>

                <v-list-button
                  name="删除"
                  icon="bin"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确定要删除此课程难度吗？"
                  :is-last="true"
                />
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/course-difficulty';

export default {
  name: RouteConfig.courseDifficultyList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (!id) return this.$message.warning('缺少课程难度 ID，无法删除该课程难度！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.error('缺少课程难度信息，无法删除！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, { update_time });
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
